/**
 * The line that says why a build failed and what to do next (utils/failureReason.js): "Build failed: <reason>. <next>",
 * `next` a link to the sandbox-type picker when Docker is off and the plan offers a type with Docker (asked of the
 * picker's own view only then), else "ask an admin".
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getMySandboxType } from '../../services/MySandboxService';
import { dockerTypeOffered, failureNote } from '../../utils/failureReason';

export default function FailureLine({ service, className = undefined, testId = undefined }) {
  const docker = Boolean(failureNote(service)?.docker);
  const [dockerType, setDockerType] = useState(null);
  useEffect(() => {
    if (!docker) { return undefined; }
    let live = true;
    getMySandboxType().then((view) => { if (live) { setDockerType(dockerTypeOffered(view)); } }).catch(() => {});
    return () => { live = false; };
  }, [docker]);
  const note = failureNote(service, { dockerType });
  if (!note) { return null; }
  const reason = note.reason.replace(/[.\s]+$/, '');
  return (
    <span className={className} data-testid={testId}>
      {`Build failed: ${reason}. `}
      {note.link ? <Link to={note.link}>{note.next}</Link> : note.next}
    </span>
  );
}

FailureLine.propTypes = { className: PropTypes.string, service: PropTypes.object, testId: PropTypes.string };
